<div class="badge">
    <div class:pickedCard={profile.pickedCard} class="image" style="background-image:url('{profile.img}');"></div>
    <div class="name">{profile.name}</div>
</div>

<style>
.badge{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
}
.image{
    width: 40px;
    height: 40px;
    background-size: contain;
    background-position: 50% 50%;
    border-radius: 50%;
    border: 3px solid #cdcdcd;
    background-color: #fff;
}
.name{
    font-size: 0.8em;
    font-weight: 200;
}
.pickedCard{
    border: 3px solid green;
}
</style>

<script>
export let profile
</script>